import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#23252C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21 21H4.6l-1-.1a1 1 0 0 1-.5-.4L3 19.4V3m18 4-5.4 5.4-.4.4h-.4l-.4-.4-1.8-1.8-.4-.4h-.4l-.4.4L7 15m14-8h-4m4 0v4"
    }, null, -1)
  ]))]))
}
export default { render: render }